var AuthorizedRouteLegacy = require('../mixins/authorized-route-legacy')
var Scope = require('../utils/scope')

module.exports = Em.Route.extend(AuthorizedRouteLegacy, {
    scopes: [Scope.OrganizationFeatureWrite]
})
